import type { ActionTypeEntity } from '@/domains/actionType/actionType.entity';
import type { ActionTypeRepository } from '@/domains/actionType/actionType.repository';

/**
 * Use Case para obtener todos los tipos de acción disponibles en el sistema.
 *
 * Funcionalidad:
 * - Recupera el listado completo de tipos de acciones académicas registradas
 * - Proporciona el catálogo de acciones disponibles para aplicar a estudiantes
 * - Obtiene los datos desde el repositorio
 *
 * Responsabilidades:
 * - Coordinar la obtención de tipos de acción con el repositorio
 * - Actuar como intermediario entre dominio e infraestructura
 * - Retornar el listado completo de tipos de acción disponibles
 * - Asegurar que los datos retornados sean consistentes
 */
export class GetActionTypesUseCase {
  private repository: ActionTypeRepository;

  /**
   * Inicializa el UseCase con las dependencias necesarias.
   *
   * @param repository - Repositorio que implementa ActionTypeRepository para operaciones de consulta
   */
  constructor(repository: ActionTypeRepository) {
    this.repository = repository;
  }

  /**
   * Ejecuta la obtención de todos los tipos de acción del sistema.
   */
  async execute(): Promise<ActionTypeEntity[]> {
    return await this.repository.getActionTypes();
  }
}
